import { Userpilot } from 'userpilot';
import { Deserializer } from 'jsonapi-serializer';
import { BulkDeleteTasksResponse } from 'api/tasksList';
import { JsonApiResponse } from 'types/store/jsonApi';
import { TaskListFilters } from 'types/store/tasksList';
import { RootState } from 'state/store';
import { selectUserEmail, selectOrganizationId } from 'state/User/userSlice';
import { USERPILOT_EVENTS } from 'utils/constants';

export interface GetBulkDeleteTasksUrlParams {
  filters?: TaskListFilters;
  exportState?: {
    selectAll: boolean;
    excludedIds: string[];
    selectedIds: string[];
  };
  projectId: string;
}

export const getBulkDeleteTasksUrl: (
  params: GetBulkDeleteTasksUrlParams
) => string = (params) => {
  const baseUrl = `/v3/projects/${params.projectId}/tasks`;
  const urlParams = new URLSearchParams();
  const { filters, exportState } = params;
  if (filters) {
    Object.entries(filters).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        value.forEach((v) => {
          urlParams.append(`filters[${key}][]`, v);
        });
      } else {
        if (value) {
          urlParams.append(`filters[${key}]`, value.toString());
        }
      }
    });
  }
  if (exportState) {
    if (exportState.selectAll) {
      urlParams.append('selectAll', exportState.selectAll.toString());
    }
    if (exportState.excludedIds && exportState.excludedIds.length > 0) {
      exportState.excludedIds.forEach((id) => {
        urlParams.append('excludedIds[]', id);
      });
    }
    if (exportState.selectedIds && exportState.selectedIds.length > 0) {
      exportState.selectedIds.forEach((id) => {
        urlParams.append('selectedIds[]', id);
      });
    }
  }
  return `${baseUrl}?${urlParams.toString()}`;
};

export const deserializeBulkDeleteTasksResponse = (
  response: JsonApiResponse<BulkDeleteTasksResponse>
) => {
  return new Deserializer({
    keyForAttribute: 'camelCase',
    transform: (record: BulkDeleteTasksResponse) => {
      return {
        attemptedCount: record.attemptedCount,
        successfulCount: record.successfulCount,
        failedCount: record.failedCount,
        operationId: record.operationId,
      };
    },
  }).deserialize(response) as unknown as Promise<BulkDeleteTasksResponse>;
};

export const trackBulkDeleteEvent = (
  state: RootState,
  response: BulkDeleteTasksResponse
) => {
  const userEmail = selectUserEmail(state);
  const organizationId = selectOrganizationId(state);
  Userpilot.track(USERPILOT_EVENTS.TASK_BULK_DELETED, {
    email: userEmail,
    companyId: organizationId,
    operationId: response.operationId,
    successfulCount: response.successfulCount,
    failedCount: response.failedCount,
    totalCount: response.successfulCount + response.failedCount,
  });
};
